import { zdarKidsCustomCiphers } from '../zdarKidsGameCustomCiphers';
import audio from '../../../../assets/audio/kids-tracks/Text22.mp3';

export const step31church = {
    id: 31,
    title: 'Kostel',
    taskText: `
        <p>
            Koukej, tady je moje kámoška Linda. Potlouká se tu teprve chvilku, je to ještě kotě, ale třeba taky něco ví.
        </p>
        <p>
            „Ahojky, co tu děláte? Hledáte něco?“ 
        </p>
        <p>
            „Ahoj Lindo, pomůžeš nám zjistit, proč se to tu jmenuje Zelená hora?“
        </p>
        <p>
            „Něco jsem zaslechla od průvodce, ale radši bych to prozkoumala i sama.“
        </p>
        <p>
            „Tak jo, dlouho jsem tu nebyl, co budeme hledat?“
        </p>
        <p>
            „Mám nápad, co kdybychom našli...“
        </p>
    `,
    cipher: {
        custom: zdarKidsCustomCiphers.church,
        label: 'Úkol',
    },
    continueButtonText: 'Mám hotovo',
    points: true,
    audio: audio,
};
